import { type ComponentProps, forwardRef } from 'react';

import { type ComponentWithAs, Input, type InputProps } from '@chakra-ui/react';
import { type DefaultInputComponentProps } from 'react-phone-number-input';
import RPNInput from 'react-phone-number-input/input';

export type PhoneNumberInputProps = ComponentProps<
  ComponentWithAs<'input', InputProps>
> &
  DefaultInputComponentProps;

const PhoneNumberInput = forwardRef<HTMLInputElement, PhoneNumberInputProps>(
  (props, ref) => {
    return <Input as={RPNInput} {...props} ref={ref} />;
  }
);

PhoneNumberInput.displayName = 'PhoneNumberInput';
export { PhoneNumberInput };
